<template>
    <el-dialog v-model="dialogDirShow" :close-on-click-modal="false" class="form-dialog" width="500px">
        <el-row>
            <el-col :span="24">
                <div class="flex toolbar-btn-action">
                    <el-button type="primary" @click="topButAdd"><ui-icon type="add-select" /> 新增</el-button>
                </div>
                <el-tree class="tree-box" :data="menusList" node-key="id" default-expand-all :expand-on-click-node="false" :props="{ children: 'child', label: 'title' }">
                    <template #default="{ node, data }">
                        <div class="custom-tree-node">
                            <div class="tree-label">
                                <div class="title">
                                    <ui-icon v-if="data.icon" :type="data.icon" /> {{ node.label }}
                                </div>
                                <div>
                                    <template v-if="data.url_value">
                                        <ui-icon v-if="!data.is_auth" type="link" />
                                        <ui-icon v-else type="unlock" />
                                    </template>
                                    {{ data.url_value }}
                                </div>
                            </div>
                            <div class="tree-node-but">
                                <el-tooltip class="box-item" effect="dark" content="新增子节点" placement="top">
                                    <el-button type="text" @click="nodeAdd(node, data)">
                                        <ui-icon class="el-menu-top-icon" type="add-select" />
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="box-item" effect="dark" content="编辑" placement="top">
                                    <el-button type="text" @click="nodeEdit(node, data)">
                                        <ui-icon class="el-menu-top-icon" type="editor1" />
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="box-item" effect="dark" content="删除" placement="top">
                                    <el-button type="text" @click="nodeDelete(node, data)">
                                        <ui-icon class="el-menu-top-icon" type="ashbin" />
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                </el-tree>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive, inject } from 'vue'
    import { ElMessage, ElMessageBox } from 'element-plus'
    import Api from '@/config/api'

    export default defineComponent({
        components: {
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()
            const dialogDirShow = inject('dialogDirShow')
            const addFormRef = ref()
            const formTitle = ref()
            const menusList = inject('menus')

            const topButAdd = () => {
                ElMessageBox.prompt('分类名称', '创建分类', {
                    confirmButtonText: '提交',
                    cancelButtonText: '取消',
                    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*?/,
                    inputErrorMessage: '请输入名称'
                }).then(({ value }) => {
                    proxy.jiu.request(Api.AdminAttachmentDirAdd, { title: value }, 'POST').then((res, rej) => {
                        context.emit('update:getDirList')
                    }).catch((error) => {
                        proxy.jiu.showError(error)
                    })
                })
            }

            const nodeAdd = (node, data) => {
                ElMessageBox.prompt('分类名称', '创建分类', {
                    confirmButtonText: '提交',
                    cancelButtonText: '取消',
                    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*?/,
                    inputErrorMessage: '请输入名称'
                }).then(({ value }) => {
                    proxy.jiu.request(Api.AdminAttachmentDirAdd, { title: value, pid: data.id }, 'POST').then((res, rej) => {
                        context.emit('update:getDirList')
                    }).catch((error) => {
                        proxy.jiu.showError(error)
                    })
                })
            }
            const nodeEdit = (node, data) => {
                ElMessageBox.prompt('分类名称', '创建分类', {
                    confirmButtonText: '提交',
                    cancelButtonText: '取消',
                    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*?/,
                    inputErrorMessage: '请输入名称'
                }).then(({ value }) => {
                    proxy.jiu.request(Api.AdminAttachmentDirEdit, { title: value, id: data.id }, 'POST').then((res, rej) => {
                        context.emit('update:getDirList')
                    }).catch((error) => {
                        proxy.jiu.showError(error)
                    })
                })
            }
            const nodeDelete = (node, data) => {
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        proxy.jiu.request(Api.AdminAttachmentDirDel, { id: data.id }).then((res, rej) => {
                            proxy.jiu.toast(res.message)
                            context.emit('update:getDirList')
                        }).catch((error) => {
                            proxy.jiu.showError(error)
                        })
                    }
                }, 'warning')
            }
            return {
                menusList,
                formTitle,
                dialogDirShow,

                topButAdd,
                nodeAdd,
                nodeEdit,
                nodeDelete
            }
        }
    })
</script>
<style>
    .tree-box .el-tree-node__content{
        height: auto;
    }
    .custom-tree-node{
        display: flex;
    }
    .tree-label{
        font-size: 14px;
        line-height: 2.3;
        display: flex;
    }
    .tree-label .title{
        margin-right: 10px;
        font-weight: bold;
    }
    .tree-node-but{
        margin-left: 20px;
    }
    .tree-node-but .el-button{
        padding: 0;
    }
    .el-tree-node__content .tree-node-but{
        display: none;
    }
    .el-tree-node__content:hover .tree-node-but{
        display: block;
    }
    .el-tree-node.is-expanded.is-penultimate .el-tree-node__content:hover,
    .el-tree-node.is-expanded.is-penultimate.is-current .el-tree-node__content,
    .el-tree-node.is-expanded.is-penultimate .el-tree-node__content{
        background: #FFD5D0;
        color: #D2847B;
    }
</style>
